import React from 'react';
import './ui.css';

/**
 * Square icon button. 34px by default, 28px for the in-row `⋯` and pager buttons.
 * `bordered` gives it the 1px outline used by the pager and the top bar's bell.
 */
const IconButton = React.forwardRef(function IconButton(
  {
    icon,
    size = 'md',
    bordered = false,
    active = false,
    label,
    dot = false,
    className = '',
    type = 'button',
    ...rest
  },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      aria-label={label}
      title={label}
      className={[
        'sv-icon-btn',
        `sv-icon-btn--${size}`,
        bordered ? 'sv-icon-btn--bordered' : '',
        active ? 'is-active' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      <i className={`bx ${icon}`} aria-hidden="true" />
      {dot && <span className="sv-icon-btn__dot" aria-hidden="true" />}
    </button>
  );
});

export default IconButton;
